import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-duplicate-modifiers-report',
  templateUrl: './duplicate-modifiers-report.component.html',
  styleUrls: ['./duplicate-modifiers-report.component.scss']
})
export class DuplicateModifiersReportComponent implements OnInit {


  constructor( ) { }
  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/manager-reports/duplicate-modifiers-report/duplicate-modifiers-report.component.ts